export default {
  WORK_TYPE: 'laboral',
  EDUCATION_TYPE: 'educational',
  OTHER_TYPE: 'other',
}
